/**
 * App Routes
 */
import React from 'react';
import {connect} from 'react-redux';
import {Redirect, Route, Switch, withRouter} from 'react-router-dom';
// app default layout
import RctAppLayout from './RctAppLayout';
// router service
import routerService from '../services/_routerService.ts';
import storage from '../fetchApi/storage';
import {accessTokenLocalStorageKey} from '../constants';

const DefaultLayout = ({match}) => {
    const accessToken = storage.load(accessTokenLocalStorageKey);
    if (!accessToken) {
        return (<Redirect to='/signin'/>);
    }

    const {highestRole} = accessToken;

    return (
        <RctAppLayout>
            <Switch>
                {routerService && routerService.length &&
                routerService.map((route, key) => {
                    const {allowedRoles, path, component} = route;

                    if (allowedRoles && (
                        allowedRoles.length === 0 ||
                        !allowedRoles.includes(highestRole)
                    )) {
                        return null;
                    }

                    return (
                        <Route
                            key={key}
                            path={`${match.url}${path}`}
                            component={component}
                        />
                    );
                })}
                <Redirect to='/' />
            </Switch>
        </RctAppLayout>
    );
};

export default withRouter(connect(null)(DefaultLayout));
